import React from 'react';
import ClientExpenses from '../client/Expenses';

const OperatorGastos = () => {
  return <ClientExpenses />;
};

export default OperatorGastos;
